import { render } from "./MatrizesVisualizarModal.vue?vue&type=template&id=b8e4b2aa"
import script from "./MatrizesVisualizarModal.vue?vue&type=script&lang=js"
export * from "./MatrizesVisualizarModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__